export var passwordErrorMessages = {
  required: "Please choose a stronger password.",
  tooWeak: "Try adding symbols or uncommon words. Don't reuse a password from another site.",
  notSecure: "This password has been previously compromised in a data breach. This data breach was unrelated to Segment, but we make it our priority to ensure your account is secure.",
  tooShort: "Your password must be at least 8 characters."
};